import { LicenseType } from "@viamap/viamap2-common";
import { Feature, FeatureType } from "./ApplicationStateFeatures";

export enum AppMode {
    Normal = "Normal",
    ReadOnly = "ReadOnly",
    Embedded = "Embedded",
}
export enum DeviceScreenSize {
    Normal = "Normal",
    Phone = "Phone",
    Tablet = "Tablet",
}

export type FeatureAllowDenyListMap = {
    [key: string]: {
        note?: string; // Optional note for the specific role
        allow: FeatureType[];
        deny: FeatureType[];
    };
};

// Features for Regionerner
export const Regionerne = [
    Feature.SpatialExportGeoJSONInverse,
    Feature.SpatialExportGeoJsonPreview,
    Feature.MeasurementToolSpatial,
];

export const BasicFeatures = [
    Feature.BasicMap,
    Feature.ExplorerDiscover,
    Feature.CreateMarker,
    Feature.GeoCoding,
    Feature.ImportEnableGrid,
    Feature.MapStyleBlank,
    Feature.GettingStarted,
    Feature.ShowReleases,
    Feature.MapStyleAerial,
    Feature.MapStyleViamap,
    Feature.SaveMap,
    Feature.SearchBar,
    Feature.ShowLayerControls,
    Feature.ShowMapScale,
    Feature.ShowMapSettings,
    Feature.ShowMenu,
    Feature.PiechartClustering,
    Feature.MapStyleDark,
    Feature.MapStyleLight,
    Feature.MapStyleContrast,
    Feature.DeviceLocation,
    Feature.MeasurementTool,
    Feature.DuplicateLayer,
    Feature.CopyPasteStyling,
    Feature.BroadcastReceiver,
];
if (process.env.NODE_ENV === "development") {
    BasicFeatures.push(
        Feature.Kortudsnit,
        Feature.Debugging,
        Feature.SimulateOtherUser,
        Feature.EditAccessRights,
        Feature.RawExplorer,
        Feature.SwapLicense,
        Feature.EditCustomFeatureLayers,
        Feature.SaveMapCloud,
        Feature.SaveMapCustomerCloud,
        // Feature.SaveMapAdminCloud,
        Feature.EarlyPreview,
        Feature.EditDataLayer,
        Feature.TravelTimeCalculateSeparately,
        Feature.DuplicateLayerFiltered,
        // Feature.SettingsCustomer,
        Feature.MovePointPositions,
        Feature.Datarapport,
        Feature.Websocket,
        Feature.WebsocketGlobalChat,
        Feature.JobModule,
        Feature.JobModuleAdmin,
        Feature.JobModuleGlobalAdmin,
        Feature.Matrikeloversigt,
        Feature.Markoversigt,

        Feature.FRPTool,
        Feature.FRPToolAdmin,
        Feature.FRPToolGlobalAdmin,
        Feature.FRPToolWriteAccess,
        Feature.PLATool,
        Feature.PLAToolAdmin,
        Feature.PLAToolGlobalAdmin,
        Feature.PLAToolWriteAccess,
        Feature.Servitutoversigt,
        Feature.ServitutRedegoerelse,
        Feature.ServitutRedegoerelseB,
        Feature.FetchTingbogAktBilag,
        Feature.SaveLinkAllowMapPlot,
        Feature.Servituterklaering,
        Feature.DrawCircle,
        Feature.MapPlotLogo,
        Feature.PropertyExcel,
        Feature.ServitutDetaljer,
        Feature.AdkomstDetaljer,
        Feature.ConflictSearch,
        Feature.ConflictSheet,
        Feature.ConflictReport,
        Feature.ConflictMap,
        Feature.PantSkema,
        Feature.LayerFunctions,
        Feature.LayerFunctions,
        Feature.LayerFunctionGroup,
        Feature.LayerFunctionCombine,
        Feature.LayerFunctionExplode,
        Feature.LayerFunctionEnvelope,
        Feature.LayerFunctionCenter,
        Feature.LayerFunctionCenterOfMass,
        Feature.LayerFunctionCentroid,
        Feature.LayerFunctionFlatten,
        Feature.LayerFunctionSimplify,
        Feature.LayerFunctionBuffer,
        Feature.LayerFunctionArea,
        Feature.LayerFunctionDistance,
        Feature.LayerFunctionLength,
        Feature.LayerFunctionBboxClip,
        Feature.LayerFunctionCircle,
        Feature.LayerFunctionClone,
        Feature.LayerFunctionConcave,
        Feature.LayerFunctionConvex,
        Feature.LayerFunctionDifference,
        Feature.LayerFunctionDissolve,
        Feature.LayerFunctionIntersect,
        Feature.LayerFunctionLineOffset,
        Feature.LayerFunctionPolygonSmooth,
        Feature.LayerFunctionUnion,
        Feature.LayerFunctionVoronoi,
        Feature.LayerFunctionLineToPolygon,
        Feature.LayerFunctionPolygonToLine,
        Feature.LayerFunctionPolygonize,
        Feature.LayerFunctionKinks,
        Feature.DyrkedeMarker,
        ...BasicFeatures,
    );
}

export const PremiumFeatures = [
    Feature.POI,
    Feature.PoiSaveAsNewLayer,
    Feature.SpatialExport,
    Feature.SpatialExportGeoJSON,
    Feature.IntersectingPolygons,

    Feature.SaveLink,
    Feature.SaveLinkReuseMapLink,
    Feature.SaveLinkSetRestrictions,
    Feature.SaveLinkSelectFeatureLayers,
    Feature.SaveLinkAllowLogin,
    Feature.SaveLinkMetaData,

    Feature.ImportPhotos,
    Feature.ImageOverlay,

    Feature.TravelTime,
    Feature.TravelTimeRushHourMode,
    Feature.TravelTimeDownloadPolygons,
    Feature.TravelTimeMultiple,
    Feature.ObliquePhoto,
    Feature.PropertyInfo,
    Feature.BoligmarkedsStatistik,
    Feature.OpenPropetyInfoDocument,
    Feature.PrintPropertyInfo,
    Feature.FavoriteBackgroundLayers,
    Feature.Jordforureningsattest,

    Feature.DuplicateLayer,

    ...Regionerne
];

//Estate Basic & Estate PRO
export const EstateBackgroundLayers = [
    Feature.BackgroundLayerAdmGrænser,
    Feature.BackgroundLayerAdmGrænserStednavne,
    Feature.BackgroundLayerCadaster,
    Feature.BackgroundLayerPlanData,
    Feature.BackgroundLayerPlanDataFingerPlan,
    Feature.BackgroundLayerPlanDataForsyning,
    Feature.BackgroundLayerByggeBeskyt,
    Feature.BackgroundLayerVejeTrafikVolumen,
    Feature.BackgroundLayerForurening,
    Feature.BackgroundLayerFloodingFromSea,
    Feature.BackgroundLayerOwnerInformation,
    Feature.BackgroundLayerPlanDataTrafikAnlæg,

    Feature.BackgroundLayerStøj,
];

export const VisualizeBackgroundLayers = [
    Feature.BackgroundLayerAdmGrænser,
    Feature.BackgroundLayerAdmGrænserStednavne,
];

export const LookupBackgroundLayers = [
    Feature.BackgroundLayerAdmGrænser,
    Feature.BackgroundLayerAdmGrænserStednavne,
    Feature.BackgroundLayerCadaster,
    Feature.BackgroundLayerPlanData,
    Feature.BackgroundLayerPlanDataFingerPlan,
    Feature.BackgroundLayerPlanDataForsyning,
    Feature.BackgroundLayerByggeBeskyt,
    Feature.BackgroundLayerBeskyttetNatur,
    Feature.BackgroundLayerVejeTrafikVolumen,
    Feature.BackgroundLayerForurening,
    Feature.BackgroundLayerOwnerInformation,
    Feature.BackgroundLayerBiodiversitet,
    Feature.BackgroundLayerVandløbOversvoemmelse,
];

export const SurveyorBackgroundLayers = [
    Feature.MapStyleAerialNoMask,

    // Uddeleger til lag
    Feature.BackgroundLayerHistoriskeKort,
    Feature.BackgroundLayerHistoriskeOrtofoto,
    Feature.BackgroundLayerMidlertidigeOrtofoto,
    Feature.BackgroundLayerOrtofotoSommer,
    Feature.BackgroundLayerAdmGrænser,
    Feature.BackgroundLayerAdmGrænserExtended,
    Feature.BackgroundLayerAdmGrænserStednavne,
    Feature.BackgroundLayerCadaster,
    Feature.BackgroundLayerCadasterForeløbigSimple,
    Feature.BackgroundLayerAnvendelse,
    Feature.BackgroundLayerPlanData,
    Feature.BackgroundLayerPlanDataForsyning,
    Feature.BackgroundLayerPlanDataKonsekvens,
    Feature.BackgroundLayerPlanDataFingerPlan,
    Feature.BackgroundLayerFredningerKulturArv,
    Feature.BackgroundLayerByggeBeskyt,
    Feature.BackgroundLayerBeskyttetNatur,
    Feature.BackgroundLayerVeje,
    Feature.BackgroundLayerVejeTrafikVolumen,
    Feature.BackgroundLayerForurening,
    Feature.BackgroundLayerMarkblokke,
    Feature.BackgroundLayerMarkblokkeHist,
    Feature.BackgroundLayerGeoDanmark,
    Feature.BackgroundLayerDHM,
    Feature.BackgroundLayerDDM,
    Feature.BackgroundLayerFikspunkt,
    Feature.BackgroundLayerSkovFonden,
    Feature.BackgroundLayerFloodingFromSea,
    Feature.BackgroundLayerOwnerInformation,
    Feature.BackgroundLayerRainFall,
    Feature.BackgroundLayerJordbrug,
    Feature.BackgroundLayerJordbrugVand,
    Feature.BackgroundLayerRetention,

    Feature.BackgroundLayerStøj,
    Feature.BackgroundLayerStøjNat,

    Feature.BackgroundLayerBiodiversitet,
    Feature.BackgroundLayerVandløbOversvoemmelse,

    Feature.BackgroundLayerPlanDataTrafikAnlæg,
    Feature.BackgroundLayerJordbrugDrikkevand,
    Feature.BackgroundLayerGrundvand,
    Feature.BackgroundLayerMiljoe,
];

export const PropertyFeatures = [
    Feature.BackgroundLayerCadaster,
    Feature.BackgroundLayerZoning,
    Feature.BackgroundLayerLocalPlans,
    Feature.BackgroundLayerCadasterPoints,
    Feature.BackgroundLayerPrivatVej,
    Feature.BackgroundLayerStrandBeskyttelsesLinjer,
    Feature.BackgroundLayerForeloebigeSkel,
    Feature.BackgroundLayerFredsskov,
    Feature.BackgroundLayerJordforurening_NuanceringV2,
    Feature.BackgroundLayerJordforureningV1,
    Feature.PropertyInfo,
    Feature.EjerlavMatrikelSearch,
    Feature.VisSamletFastEjendom,
    Feature.VisVurderingsejendom,
    Feature.VisMatrikel,
    Feature.BoligmarkedsStatistik,
    Feature.DownloadAktFraTinglysning,
    Feature.FetchNewTingbogAllow,
    Feature.PlandataAflyst,
    Feature.PlandataForslag,
];

export const ExplorerBasic = [
    //    Feature.ThemeNewSec,
    Feature.Explorer,
    Feature.BasicMap,
    Feature.ExplorerDiscover,
    Feature.ExplorerProjects,
    Feature.ExplorerExplore,
    Feature.ExplorerOwnership,
    //    Feature.AddToProjectUnassignedList, Disabled due to new project structure
    Feature.PropertyInfoFavorite,
    Feature.ExplorerToExcel,
    Feature.PropertyExcel,
    Feature.ExplorerSaveAsNewLayer,
    Feature.ExplorerShowAsList,
    Feature.ExplorerSearchByMapLayer,
    Feature.LinkToMunicipalityWebDocuments,
];

export const ExplorerPro = [
    Feature.ExplorerMarkedsData,
    Feature.ViewCustomFeatureLayers,
    Feature.BackgroundLayerRainFall,
    Feature.BackgroundLayerBiodiversitet,
    Feature.BackgroundLayerVandløbOversvoemmelse,
    Feature.BackgroundLayerStøjNat,
    Feature.BackgroundLayerBeskyttetNatur,
    Feature.BackgroundLayerJordbrug,
];

export const ExplorerDemo = [Feature.ExplorerDashboard];

/**
 * Customer Administrator Features
 */

export const ProAdminFeatures = [Feature.CustomUserSettingAdmin];

export const PremiumAdminFeatures = [Feature.EditCustomFeatureLayers];

export const PropertyAdminFeatures = [];

export const MinimalFeaturesRole = "MINIMAL_FEATURES_FOR_ANY_USER";

/**
 * User Role Based Access Parameters
 */
export const UserRole2Features: FeatureAllowDenyListMap = {
    /* --------------------------------------------------------------- */
    [MinimalFeaturesRole]: {
        allow: [],
        deny: [],
    },

    /**
     * All licensed packages
     */

    Visualize: {
        allow: [...BasicFeatures, ...VisualizeBackgroundLayers, Feature.CreateMarkerNavigation],
        deny: [],
    },
    Lookup: {
        allow: [
            ...BasicFeatures,
            ...PremiumFeatures,
            ...LookupBackgroundLayers,
            Feature.CreateMarkerNavigation,
        ],
        deny: [],
    },
    Surveyor: {
        allow: [
            ...BasicFeatures,
            ...PremiumFeatures,
            ...PropertyFeatures,
            ...SurveyorBackgroundLayers,

            Feature.mapStyleMod,
            Feature.SearchFallBack,
            Feature.MapPlot,
            Feature.ExplorerExplore,
            Feature.ExplorerOwnership,
            Feature.AllowConsolidateDuplicates,
            Feature.PropertyInfoFavorite,
            Feature.ExplorerToExcel,
            Feature.PropertyExcel,
            Feature.ExplorerSaveAsNewLayer,
            Feature.ExplorerShowAsList,
            Feature.ExplorerSearchByMapLayer,
            Feature.LinkToMao,
            Feature.CreateMarkerNavigation,
            Feature.EditDataLayer,
            Feature.ServitutTilExcel,
            Feature.SaveLinkSelectSearchOptions,
            Feature.SaveLinkSelectSearchBehaviour,
            Feature.SaveLinkShowUserLocation,
            Feature.ShareFavoriteBackgroundLayers,
            Feature.MapPlotLogo,
            Feature.SaveLinkAllowMapPlot,
            Feature.DrawCircle,
            Feature.EditMapDescription,
            Feature.MovePointPositions,
            Feature.ExplorerImportExport,
            Feature.DuplicateLayerFiltered,
            Feature.StylingSelectPointType,
            Feature.LinkToMunicipalityWebDocuments,
            Feature.LinkHistoriskeKort
        ],
        deny: [],
    },
    Explorer: {
        allow: [
            ...BasicFeatures,
            ...PremiumFeatures,
            ...PropertyFeatures,
            ...ExplorerBasic,
            ...EstateBackgroundLayers,
            Feature.ThemeNewSec,
        ],
        deny: [Feature.GettingStarted],
    },
    ExplorerPro: {
        allow: [
            ...BasicFeatures,
            ...PremiumFeatures,
            ...PropertyFeatures,
            ...ExplorerBasic,
            ...ExplorerPro,
            ...EstateBackgroundLayers,
            Feature.ExplorerMarkedsData,
            Feature.ViewCustomFeatureLayers,
            Feature.BackgroundLayerRainFall,
            Feature.ThemeNewSec,
        ],
        deny: [Feature.GettingStarted],
    },

    /* --------------------------- OLD PACKAGES ------------------------ */
    Basic: {
        allow: BasicFeatures,
        deny: [],
    },
    Pro: {
        allow: [...BasicFeatures],
        deny: [],
    },
    Premium: {
        allow: [...BasicFeatures, ...PremiumFeatures],
        deny: [],
    },
    Property: {
        allow: [...BasicFeatures, ...PremiumFeatures, ...PropertyFeatures],
        deny: [],
    },
    ProAdmin: {
        allow: [...ProAdminFeatures],
        deny: [],
    },
    PremiumAdmin: {
        allow: [...ProAdminFeatures, ...PremiumAdminFeatures],
        deny: [],
    },
    PropertyAdmin: {
        allow: [...ProAdminFeatures, ...PremiumAdminFeatures, ...PropertyAdminFeatures],
        deny: [],
    },

    /* Applies to all costumers before Feb2020 when the basic rights were reduced.
          All customer who signed up before Feb2020 should (also) have this access right */
    "BasicPre2020": {
        allow: [
            Feature.BasicMap, Feature.GeoCoding, Feature.SaveMap,
            Feature.ShowLayerControls, Feature.ShowMenu, Feature.ShowMapScale,
            Feature.ShowMolbakLogoOnGeodataReport, Feature.SearchBar,
            Feature.GettingStarted, Feature.BackgroundLayerCadaster,
            Feature.MapStyleViamap,
            Feature.MapStyleAerial,
            Feature.MapStyleContrast,
            Feature.MapStyleDark,
            Feature.MapStyleLight,
            Feature.CreateMarker
        ],
        deny: []
    },
    "SelfSignedupTrial": {
        allow: [],
        deny: []
    },
    /* --------------------------------------------------------------- */
    "Landbrug": {
        allow: [
            Feature.Datarapport,
            Feature.Markoversigt,
            Feature.Matrikeloversigt,
            Feature.Servitutoversigt,
            Feature.ConflictSearch,
        ],
        deny: []
    },
    "Administrator": {
        allow: [Feature.UserAdmin],
        deny: []
    },
    "DebuggingOpenAllLinks": {
        allow: [Feature.DebuggingOpenAllLinks],
        deny: []
    },
    "EarlyPreview": {
        allow: [
            Feature.EarlyPreview,
            Feature.ConflictSearch,
            Feature.StylingSelectTextFont,
            Feature.PoiSaveAsNewLayer,
            Feature.MapPlotSuper,
            Feature.ExportFloodingProperties,
            Feature.PantSkema,
            Feature.DyrkedeMarker
        ],
        deny: []
    },
    "Debugging": {
        allow: [
            Feature.Servituterklaering,
            Feature.Debugging,
            Feature.EarlyPreview,
            Feature.SimulateOtherUser,
            Feature.EditAccessRights
        ],
        deny: []
    },
    "Cadaster": {
        allow: [Feature.BackgroundLayerCadaster],
        deny: []
    },
    "DataPakkeBBR": {
        allow: [Feature.BackgroundLayerBBRData],
        deny: []
    },
    "DataPakkeEjerforhold": {
        allow: [Feature.BackgroundLayerEjerData],
        deny: []
    },
    "DataPakkeZoning": {
        allow: [Feature.BackgroundLayerZoning],
        deny: []
    },
    "DataPakkeTrafikTal": {
        allow: [Feature.BackgroundLayerVejeTrafikVolumen],
        deny: []
    },
    "DataPakkeDAI": {
        allow: [Feature.BackgroundLayerDAI],
        deny: []
    },
    "DataPakkeLokalplaner": {
        allow: [Feature.BackgroundLayerLocalPlans],
        deny: []
    },
    "DataPakkePolitidistrikter": {
        allow: [Feature.BackgroundLayerPoliceDistricts],
        deny: []
    },
    "DataPakkeJordforureningV1": {
        allow: [Feature.BackgroundLayerJordforureningV1],
        deny: []
    },
    "DataPakkeJordforurening_NuanceringV2": {
        allow: [Feature.BackgroundLayerJordforurening_NuanceringV2],
        deny: []
    },
    "DataPakkeJordforurening": {
        allow: [Feature.BackgroundLayerJordforureningV1, Feature.BackgroundLayerJordforurening_NuanceringV2],
        deny: []
    },
    "DataPakkePrivatVej": {
        allow: [Feature.BackgroundLayerPrivatVej],
        deny: []
    },
    "DataPakkeStrandBeskyttelsesLinjer": {
        allow: [Feature.BackgroundLayerStrandBeskyttelsesLinjer],
        deny: []
    },
    "DataPakkeFredsskov": {
        allow: [Feature.BackgroundLayerFredsskov],
        deny: []
    },
    "DataPakkeForeloebigeSkel": {
        allow: [Feature.BackgroundLayerForeloebigeSkel],
        deny: []
    },
    "DataPakkeSommerhuse": {
        allow: [Feature.BackgroundLayerAnvendelse],
        deny: []
    },
    "POI": {
        allow: [Feature.POI],
        deny: []
    },
    "POIEVCharger": {
        allow: [Feature.POI, Feature.POIEVCharger],
        deny: []
    },
    "GeodataReport": {
        allow: [Feature.GeodataReport],
        deny: []
    },
    "GeodataReportGermany": {
        allow: [Feature.GeodataReportGermany],
        deny: []
    },
    "DeviceLocation": {
        allow: [Feature.DeviceLocation],
        deny: []
    },
    "SaveLink": {
        allow: [Feature.SaveLink, Feature.SaveLinkAllowLogin],
        deny: []
    },
    "TravelTime": {
        allow: [Feature.TravelTime, Feature.TravelTimeRushHourMode],
        deny: []
    },
    "TravelTimeMultiple": {
        allow: [Feature.TravelTimeMultiple],
        deny: []
    },
    "TravelTimeFromPoint": {
        allow: [Feature.TravelTimeFromPoint],
        deny: []
    },
    "TravelTimeDownloadPolygons": {
        allow: [Feature.TravelTimeDownloadPolygons],
        deny: []
    },
    "TravelTimeCombinedBikeAndTransit": {
        allow: [Feature.TravelTimeCombinedBikeAndTransit],
        deny: []
    },
    "TravelTimeCalculateSeparately": {
        allow: [Feature.TravelTimeCalculateSeparately],
        deny: []
    },
    "TravelTimeBufferSetting": {
        allow: [Feature.TravelTimeMultipleBufferSetting],
        deny: []
    },
    "SpatialExport": {
        allow: [Feature.SpatialExport, Feature.SpatialExportGeoJSON],
        deny: []
    },
    "RawExplorer": {
        allow: [Feature.RawExplorer],
        deny: []
    },
    "ObliquePhoto": {
        allow: [Feature.ObliquePhoto],
        deny: []
    },
    "DataPakkeDayNightPopulation": {
        allow: [Feature.BackgroundLayerDayNightPopulation],
        deny: []
    },
    "MapStyleViamap": {
        allow: [
            Feature.MapStyleViamap,
        ],
        deny: []
    },
    "MapStyleAerial": {
        allow: [
            Feature.MapStyleAerial,
        ],
        deny: []
    },
    "MapStyleContrast": {
        allow: [
            Feature.MapStyleContrast,
        ],
        deny: []
    },
    "MapStyleDark": {
        allow: [
            Feature.MapStyleDark,
        ],
        deny: []
    },
    "MapStyleLight": {
        allow: [
            Feature.MapStyleLight,
        ],
        deny: []
    },
    "MapStyler": {
        allow: [
            Feature.mapStyle_Americana,
            Feature.mapStyle_Bright,
            Feature.mapStyle_DarkMatter,
            Feature.mapStyle_Outdoors,
            Feature.mapStyle_Positron,
            Feature.mapStyle_Toner,
            Feature.mapStyle_Balder,
            Feature.mapStyle_Campaya,
            Feature.mapStyle_Danbolig,
            Feature.mapStyle_GenericDefaultStyle,
            Feature.mapStyle_Kjeldskov,
            Feature.mapStyle_Klokantech,
            Feature.mapStyle_Marselisborg,
        ],
        deny: []
    },
    "AllLayerFunctions": {
        allow: [
            Feature.LayerFunctions,
            Feature.LayerFunctionGroup,
            Feature.LayerFunctionCombine,
            Feature.LayerFunctionExplode,
            Feature.LayerFunctionEnvelope,
            Feature.LayerFunctionCenter,
            Feature.LayerFunctionCenterOfMass,
            Feature.LayerFunctionCentroid,
            Feature.LayerFunctionFlatten,
            Feature.LayerFunctionSimplify,
            Feature.LayerFunctionBuffer,
            Feature.LayerFunctionArea,
            Feature.LayerFunctionDistance,
            Feature.LayerFunctionLength,
            Feature.LayerFunctionBboxClip,
            Feature.LayerFunctionCircle,
            Feature.LayerFunctionClone,
            Feature.LayerFunctionConcave,
            Feature.LayerFunctionConvex,
            Feature.LayerFunctionDifference,
            Feature.LayerFunctionDissolve,
            Feature.LayerFunctionIntersect,
            Feature.LayerFunctionLineOffset,
            Feature.LayerFunctionPolygonSmooth,
            Feature.LayerFunctionUnion,
            Feature.LayerFunctionVoronoi,
            Feature.LayerFunctionLineToPolygon,
            Feature.LayerFunctionPolygonToLine,
            Feature.LayerFunctionPolygonize,
            Feature.LayerFunctionKinks
        ], deny: []
    },
    "LayerFunctionGroup": {
        allow: [Feature.LayerFunctionGroup, Feature.LayerFunctions],
        deny: []
    },
    "LayerFunctionCombine": {
        allow: [Feature.LayerFunctionCombine, Feature.LayerFunctions],
        deny: []
    },
    "LayerFunctionExplode": {
        allow: [Feature.LayerFunctionExplode, Feature.LayerFunctions],
        deny: []
    },
    "LayerFunctionEnvelope": {
        allow: [Feature.LayerFunctionEnvelope, Feature.LayerFunctions],
        deny: []
    },
    "LayerFunctionCenter": {
        allow: [Feature.LayerFunctionCenter, Feature.LayerFunctions],
        deny: []
    },
    "LayerFunctionCenterOfMass": {
        allow: [Feature.LayerFunctionCenterOfMass, Feature.LayerFunctions],
        deny: []
    },
    "LayerFunctionCentroid": {
        allow: [Feature.LayerFunctionCentroid, Feature.LayerFunctions],
        deny: []
    },
    "LayerFunctionFlatten": {
        allow: [Feature.LayerFunctionFlatten, Feature.LayerFunctions],
        deny: []
    },
    "LayerFunctionSimplify": {
        allow: [Feature.LayerFunctionSimplify, Feature.LayerFunctions],
        deny: []
    },
    "LayerFunctionBuffer": {
        allow: [Feature.LayerFunctionBuffer, Feature.LayerFunctions],
        deny: []
    },
    "LayerFunctionArea": {
        allow: [Feature.LayerFunctionArea, Feature.LayerFunctions],
        deny: []
    },
    "LayerFunctionDistance": {
        allow: [Feature.LayerFunctionDistance, Feature.LayerFunctions],
        deny: []
    },
    "LayerFunctionLength": {
        allow: [Feature.LayerFunctionLength, Feature.LayerFunctions],
        deny: []
    },
    "LayerFunctionBboxClip": {
        allow: [Feature.LayerFunctionBboxClip, Feature.LayerFunctions],
        deny: []
    },
    "LayerFunctionCircle": {
        allow: [Feature.LayerFunctionCircle, Feature.LayerFunctions],
        deny: []
    },
    "LayerFunctionClone": {
        allow: [Feature.LayerFunctionClone, Feature.LayerFunctions],
        deny: []
    },
    "LayerFunctionConcave": {
        allow: [Feature.LayerFunctionConcave, Feature.LayerFunctions],
        deny: []
    },
    "LayerFunctionConvex": {
        allow: [Feature.LayerFunctionConvex, Feature.LayerFunctions],
        deny: []
    },
    "LayerFunctionDifference": {
        allow: [Feature.LayerFunctionDifference, Feature.LayerFunctions],
        deny: []
    },
    "LayerFunctionDissolve": {
        allow: [Feature.LayerFunctionDissolve, Feature.LayerFunctions],
        deny: []
    },
    "LayerFunctionIntersect": {
        allow: [Feature.LayerFunctionIntersect, Feature.LayerFunctions],
        deny: []
    },
    "LayerFunctionLineOffset": {
        allow: [Feature.LayerFunctionLineOffset, Feature.LayerFunctions],
        deny: []
    },
    "LayerFunctionPolygonSmooth": {
        allow: [Feature.LayerFunctionPolygonSmooth, Feature.LayerFunctions],
        deny: []
    },
    "LayerFunctionUnion": {
        allow: [Feature.LayerFunctionUnion, Feature.LayerFunctions],
        deny: []
    },
    "LayerFunctionVoronoi": {
        allow: [Feature.LayerFunctionVoronoi, Feature.LayerFunctions],
        deny: []
    },
    "LayerFunctionLineToPolygon": {
        allow: [Feature.LayerFunctionLineToPolygon, Feature.LayerFunctions],
        deny: []
    },
    "LayerFunctionPolygonToLine": {
        allow: [Feature.LayerFunctionPolygonToLine, Feature.LayerFunctions],
        deny: []
    },
    "LayerFunctionPolygonize": {
        allow: [Feature.LayerFunctionPolygonize, Feature.LayerFunctions],
        deny: []
    },
    "LayerFunctionKinks": {
        allow: [Feature.LayerFunctionKinks, Feature.LayerFunctions],
        deny: []
    },
    "StreetView": {
        allow: [
            Feature.StreetView
        ],
        deny: []
    },
    "CustomFeatureLayers": {
        allow: [
            Feature.ViewCustomFeatureLayers
        ],
        deny: []
    },
    "CustomFeatureLayersAdmin": {
        allow: [
            Feature.ViewCustomFeatureLayers,
            Feature.EditCustomFeatureLayers,
        ],
        deny: []
    },
    "LifaOIS": {
        allow: [
            Feature.LifaOIS
        ],
        deny: []
    },
    "Kortviser": {
        allow: [
            Feature.Kortviser
        ],
        deny: []
    },
    "PropertyInfo": {
        allow: [
            Feature.PropertyInfo,
        ],
        deny: []
    },
    "EjerlavMatrikelSearch": {
        allow: [
            Feature.EjerlavMatrikelSearch,
        ],
        deny: []
    },
    "MeasurementTool": {
        allow: [
            Feature.MeasurementTool
        ],
        deny: []
    },
    "VisSamletFastEjendom": {
        allow: [
            Feature.VisSamletFastEjendom
        ],
        deny: []
    },
    "VisVurderingsejendom": {
        allow: [
            Feature.VisVurderingsejendom
        ],
        deny: []
    },
    "PiechartClustering": {
        allow: [
            Feature.PiechartClustering,
        ],
        deny: []
    },
    "CustomUserSettingAdmin": {
        allow: [
            Feature.CustomUserSettingAdmin,
        ],
        deny: []
    },
    "DataPakkeAnvendelse2021": {
        allow: [
            Feature.BackgroundLayerAnvendelse2021,
        ],
        deny: []
    },
    "ImportPhotos": {
        allow: [
            Feature.ImportPhotos,
        ],
        deny: [],
    },
    "ImportEnableSydslesvigGeom": {
        allow: [Feature.ImportEnableSydslesvigGeom],
        deny: [],
    },
    "ImportEnableGrid": {
        allow: [Feature.ImportEnableGrid],
        deny: [],
    },
    "ImportEnableRomaniaGeom": {
        allow: [Feature.ImportEnableRomaniaGeom],
        deny: [],
    },
    "SaveLinkReuseMapLink": {
        allow: [
            Feature.SaveLink,
            Feature.SaveLinkAllowLogin,
            Feature.SaveLinkReuseMapLink,
        ],
        deny: [],
    },
    "SaveLinkSetRestrictions": {
        allow: [
            Feature.SaveLink,
            Feature.SaveLinkAllowLogin,
            Feature.SaveLinkSetRestrictions,
        ],
        deny: [],
    },
    "SuperPlot": {
        allow: [
            Feature.MapPlot,
            Feature.MapPlotSuper
        ],
        deny: [],
    },
    "MapPlotCompress": {
        allow: [
            Feature.MapPlot,
            Feature.MapPlotCompress
        ],
        deny: [],
    },
    "MapPlotLogo": {
        allow: [
            Feature.MapPlot,
            Feature.MapPlotLogo
        ],
        deny: [],
    },
    "MapPlotEjendomskort": {
        allow: [
            Feature.MapPlot,
            Feature.MapPlotEjendomskort
        ],
        deny: [],
    },
    "Matrikeloversigt": {
        allow: [
            Feature.Datarapport,
            Feature.Matrikeloversigt
        ],
        deny: [],
    },
    "Markoversigt": {
        allow: [
            Feature.Datarapport,
            Feature.Markoversigt
        ],
        deny: [],
    },
    "Servitutoversigt": {
        allow: [
            Feature.Datarapport,
            Feature.Servitutoversigt
        ],
        deny: [],
    },
    "ServitutRedegoerelse": {
        allow: [
            Feature.Datarapport,
            Feature.ServitutRedegoerelse,
            Feature.DownloadAktFraTinglysning,
            Feature.FetchNewTingbogAllow,
            Feature.AnnotationModule,
            Feature.AnnotationRead,
            Feature.AnnotationWrite,
            Feature.ServitutEditor,
            Feature.ServitutAIAnalyse,
        ],
        deny: [],
    },
    "ServitutRedegoerelseB": {
        allow: [
            Feature.ServitutRedegoerelseB,
            Feature.AnnotationModule,
            Feature.AnnotationRead,
            Feature.AnnotationWrite,
            Feature.ServitutAIAnalyse,
        ],
        deny: [],
    },
    "EditDataLayer": {
        allow: [
            Feature.EditDataLayer
        ],
        deny: [],
    },
    "SaveLinkSelectFeatureLayers": {
        allow: [
            Feature.SaveLink,
            Feature.SaveLinkAllowLogin,
            Feature.SaveLinkSelectFeatureLayers,
        ],
        deny: [],
    },
    "SaveLinkSelectSearchOptions": {
        allow: [
            Feature.SaveLink,
            Feature.SaveLinkAllowLogin,
            Feature.SaveLinkSelectSearchOptions,
        ],
        deny: [],
    },
    "MovePointPositions": {
        allow: [
            Feature.MovePointPositions,
        ],
        deny: [],
    },
    "SaveLinkShowUserLocation": {
        allow: [
            Feature.SaveLink,
            Feature.SaveLinkAllowLogin,
            Feature.SaveLinkShowUserLocation,
        ],
        deny: [],
    },
    "SaveLinkAllowMapPlot": {
        allow: [
            Feature.SaveLink,
            Feature.SaveLinkAllowLogin,
            Feature.SaveLinkAllowMapPlot,
        ],
        deny: [],
    },
    "SaveLinkSelectSearchBehaviour": {
        allow: [
            Feature.SaveLink,
            Feature.SaveLinkAllowLogin,
            Feature.SaveLinkSelectSearchOptions, //Required for SaveLinkSelectSearchBehaviour to work
            Feature.SaveLinkSelectSearchBehaviour
        ],
        deny: [],
    },
    "KortUdsnitEjendom": {
        allow: [
            Feature.KortUdsnitEjendom,
        ],
        deny: [],
    },

    "SwapLicense": {
        allow: [Feature.SwapLicense,
        Feature.DownloadAktFraTinglysning,
        Feature.FetchTingbogAktBilag,
        Feature.FetchNewTingbogAllow],
        deny: []
    },
    "LinkHistoriskeKort": {
        allow: [
            Feature.LinkHistoriskeKort
        ],
        deny: []
    },
    "Molbak": {
        allow: [
            Feature.HexagonBackgroundLayerMoelbak,
            Feature.BackgroundLayerMidlertidigeOrtofoto,
            Feature.BackgroundGeusVandboringer,
            Feature.LinkHistoriskeKort,
            Feature.Servituterklaering,
            Feature.MapPlotCompress,
            Feature.DrawCircle,
            Feature.ServitutDetaljer,
            Feature.AdkomstDetaljer,
            Feature.LayerFunctions,
            Feature.LayerFunctionGroup,
            Feature.LayerFunctionCombine,
            Feature.LayerFunctionExplode,
            Feature.LayerFunctionEnvelope,
            Feature.LayerFunctionCenter,
            Feature.LayerFunctionCenterOfMass,
            Feature.LayerFunctionCentroid,
            Feature.LayerFunctionFlatten,
            Feature.LayerFunctionSimplify,
            Feature.LayerFunctionBuffer,
            Feature.LayerFunctionArea,
            Feature.LayerFunctionDistance,
            Feature.LayerFunctionLength,
            Feature.LayerFunctionBboxClip,
            Feature.LayerFunctionCircle,
            Feature.LayerFunctionClone,
            Feature.LayerFunctionConcave,
            Feature.LayerFunctionConvex,
            Feature.LayerFunctionDifference,
            Feature.LayerFunctionDissolve,
            Feature.LayerFunctionIntersect,
            Feature.LayerFunctionLineOffset,
            Feature.LayerFunctionPolygonSmooth,
            Feature.LayerFunctionUnion,
            Feature.LayerFunctionVoronoi,
            Feature.LayerFunctionLineToPolygon,
            Feature.LayerFunctionPolygonToLine,
            Feature.LayerFunctionPolygonize,
            Feature.LayerFunctionKinks
        ],
        deny: []
    },
    "Demo": {
        allow: [
            Feature.GeodataReport,
            Feature.SwapLicense,
            // Feature.ShowDemoQuickButtons,
            Feature.ExplorerImportExport,
            Feature.PrintPropertyInfo,
            Feature.PoiSaveAsNewLayer,
            Feature.StreetView,
            Feature.MapPlotSuper,
            Feature.LinkHistoriskeKort,
            Feature.ServitutDetaljer,
            Feature.AdkomstDetaljer
        ],
        deny: []
    },
    "DemoAnnotation": {
        allow: [
            Feature.AnnotationModule,
            Feature.AnnotationModuleAdmin,
            Feature.AnnotationRead,
            Feature.AnnotationWrite,
            Feature.AnnotationDelete,
            Feature.AnnotationAuthUser,
            Feature.ServitutAIAnalyse
        ],
        deny: [
        ]
    },
    "ServiMap": {
        allow: [
            Feature.Datarapport,
            Feature.DownloadAktFraTinglysning,
            Feature.FetchNewTingbogAllow,
            Feature.AnnotationModule,
            Feature.AnnotationRead,
            Feature.AnnotationWrite,
            Feature.ServitutEditor,
            Feature.ServitutAIAnalyse,
            Feature.ServitutRedegoerelse,
        ],
        deny: [],
    },
    "ServiMapB": {
        allow: [
            Feature.Datarapport,
            Feature.DownloadAktFraTinglysning,
            Feature.FetchNewTingbogAllow,
            Feature.AnnotationModule,
            Feature.AnnotationRead,
            Feature.AnnotationWrite,
            Feature.ServitutEditor,
            Feature.ServitutAIAnalyse,
            Feature.ServitutRedegoerelse,
            Feature.ServitutRedegoerelseB,
        ],
        deny: [],
    },
    "GlobalAdministrator": {
        allow: [Feature.GlobalAdministrator],
        deny: []
    },
    "CustomerAdministrator": {
        allow: [Feature.CustomerAdministrator],
        deny: []
    },
    "FRP": {
        allow: [Feature.FRPTool],
        deny: [],
    },
    "FRPAdmin": {
        allow: [Feature.FRPTool, Feature.FRPToolAdmin],
        deny: [],
    },
    "FRPGlobalAdmin": {
        allow: [Feature.FRPTool, Feature.FRPToolAdmin, Feature.FRPToolGlobalAdmin],
        deny: [],
    },
    "PLA": {
        allow: [Feature.PLATool],
        deny: [],
    },
    "PLAWriteAccess": {
        allow: [Feature.PLATool, Feature.PLAToolWriteAccess],
        deny: [],
    },
    "PLAAdmin": {
        allow: [Feature.PLATool, Feature.PLAToolAdmin, Feature.PLAToolWriteAccess],
        deny: [],
    },
    "PLAGlobalAdmin": {
        allow: [Feature.PLATool, Feature.PLAToolAdmin, Feature.PLAToolGlobalAdmin, Feature.PLAToolWriteAccess],
        deny: [],
    },
    "GEUSVandboringer": {
        allow: [Feature.BackgroundGeusVandboringer],
        deny: [],
    },
    "BNBO": {
        allow: [Feature.BNBOTool, Feature.BackgroundGeusVandboringer],
        deny: []
    },
    "BNBReadAcess": {
        allow: [Feature.BNBOTool, Feature.BNBOProjectRead, Feature.BackgroundGeusVandboringer],
        deny: []
    },
    "BNBOWriteAcess": {
        allow: [Feature.BNBOTool, Feature.BNBOToolWriteAccess, Feature.BackgroundGeusVandboringer],
        deny: []
    },
    "BNBOAdmin": {
        allow: [Feature.BNBOTool, Feature.BNBOToolWriteAccess, Feature.BNBOReplaceData, Feature.BNBOProjectRead, Feature.BNBOProjectWrite, Feature.BNBOToolAdmin, Feature.BackgroundGeusVandboringer],
        deny: []
    },
    "BNBOGlobalAdmin": {
        allow: [Feature.BNBOTool, Feature.BNBOToolWriteAccess, Feature.BNBOReplaceData, Feature.BNBOProjectRead, Feature.BNBOProjectWrite, Feature.BNBOToolAdmin, Feature.BNBOToolGlobalAdmin, Feature.BackgroundGeusVandboringer],
        deny: []
    },
    "SampantningsSkema": {
        allow: [Feature.PantSkema],
        deny: []
    },
    "DyrkedeMarker": {
        allow: [Feature.DyrkedeMarker],
        deny: []
    },
    "BNBOArrondationCalc": {
        allow: [Feature.BNBOToolArrondationCalc],
        deny: []
    },
    "JPB": {
        allow: [
            Feature.JPBTool, Feature.JPBSimulator, Feature.JPBMolbakIndexAllow, Feature.JPBRapport,
            Feature.LayerFunctions,
            Feature.LayerFunctionGroup
        ],
        deny: []
    },
    "JPBIndexTool": {
        note: "Tool for generating indexes",
        allow: [Feature.JPBIndexTool],
        deny: []
    },
    "JPBAgroCuraIndexAllow": {
        allow: [Feature.JPBAgroCuraIndexAllow],
        deny: []
    },
    "JPBMolbakIndexAllow": {
        allow: [Feature.JPBMolbakIndexAllow],
        deny: []
    },
    "JPBMolbakIndexAllowWindow": {
        note: "User feature for showing the Molbak Index in a table by year and region",
        allow: [Feature.JPBMolbakIndexAllowWindow],
        deny: []
    },
    "JPBIndeks": {
        note: "User feature for showing the Molbak Index in a table by year and region",
        allow: [Feature.JPBMolbakIndexAllowWindow],
        deny: []
    },
    "JPBRapport": {
        allow: [Feature.JPBTool, Feature.JPBRapport],
        deny: []
    },
    "JPBSimulator": {
        allow: [Feature.JPBTool, Feature.JPBSimulator],
        deny: []
    },
    "JPBExcelExport": {
        allow: [Feature.JPBTool, Feature.JPBExcelExport],
        deny: []
    },
    "JPBExportToDataLayer": {
        allow: [Feature.JPBTool, Feature.JPBExportToDataLayer],
        deny: []
    },
    "JPBLimitedProduct": {
        allow: [
            Feature.JPBTool,
            Feature.JPBSimulator,
            Feature.JPBMolbakIndexAllow
        ],
        deny: [
            Feature.POI,
            Feature.GeodataReport,
            Feature.SaveLink,
            Feature.TravelTime,
            Feature.SpatialExport,
            Feature.Explorer,
            Feature.ExplorerOwnership,
            Feature.ExplorerDiscover,
            Feature.ExplorerExplore,
            Feature.ExplorerToExcel,
            Feature.ExplorerProjects,
            Feature.StreetView,
            Feature.BoligmarkedsStatistik,
            Feature.DeviceLocation,
            Feature.DownloadAktFraTinglysning,
            Feature.FetchTingbogAktBilag,
            Feature.FetchNewTingbogAllow,
            Feature.ObliquePhoto,
            Feature.PrintPersonInfo,
            Feature.PrintPersonInfo,
            Feature.SaveLink,
            Feature.ServitutDetaljer,
            Feature.AdkomstDetaljer,
            Feature.Servituterklaering,
            Feature.StreetView,
            Feature.TravelTimeMultiple,
            Feature.PropertyInfo
        ]
    },
    "JPBIndeksLimitedProduct": {
        allow: [
            Feature.JPBMolbakIndexAllowWindow,
            Feature.JPBMolbakIndexAllow
        ],
        deny: [
            Feature.POI,
            Feature.GeodataReport,
            Feature.SaveLink,
            Feature.TravelTime,
            Feature.SpatialExport,
            Feature.Explorer,
            Feature.ExplorerOwnership,
            Feature.ExplorerDiscover,
            Feature.ExplorerExplore,
            Feature.ExplorerToExcel,
            Feature.ExplorerProjects,
            Feature.StreetView,
            Feature.BoligmarkedsStatistik,
            Feature.DeviceLocation,
            Feature.DownloadAktFraTinglysning,
            Feature.FetchTingbogAktBilag,
            Feature.FetchNewTingbogAllow,
            Feature.ObliquePhoto,
            Feature.PrintPersonInfo,
            Feature.PrintPersonInfo,
            Feature.SaveLink,
            Feature.ServitutDetaljer,
            Feature.AdkomstDetaljer,
            Feature.Servituterklaering,
            Feature.StreetView,
            Feature.TravelTimeMultiple,
            Feature.PropertyInfo,
        ]
    },
    "MapitAllowSpecializedToolsOnly": {
        allow: [
        ],
        deny: [
            Feature.POI,
            Feature.GeodataReport,
            Feature.SaveLink,
            Feature.TravelTime,
            Feature.SpatialExport,
            Feature.Explorer,
            Feature.ExplorerOwnership,
            Feature.ExplorerDiscover,
            Feature.ExplorerExplore,
            Feature.ExplorerToExcel,
            Feature.ExplorerProjects,
            Feature.StreetView,
            Feature.BoligmarkedsStatistik,
            Feature.DeviceLocation,
            Feature.DownloadAktFraTinglysning,
            Feature.FetchTingbogAktBilag,
            Feature.FetchNewTingbogAllow,
            Feature.ObliquePhoto,
            Feature.PrintPersonInfo,
            Feature.PrintPersonInfo,
            Feature.SaveLink,
            Feature.ServitutDetaljer,
            Feature.AdkomstDetaljer,
            Feature.Servituterklaering,
            Feature.StreetView,
            Feature.TravelTimeMultiple,
            Feature.PropertyInfo
        ]
    },
    "ConflictSearch": {
        allow: [Feature.ConflictSearch, Feature.ConflictSheet],
        deny: []
    },
    "FavoriteConflictSearch": {
        allow: [Feature.FavoriteConflictSearch],
        deny: []
    },
    "ConflictReport": {
        allow: [Feature.ConflictSearch, Feature.ConflictSheet, Feature.ConflictReport, Feature.ConflictMap],
        deny: []
    },
    "ExplorerMapLayer": {
        allow: [Feature.ExplorerSearchByMapLayer],
        deny: []
    },
    "Websocket": {
        allow: [Feature.Websocket],
        deny: []
    },
    "GlobalChat": {
        allow: [Feature.Websocket, Feature.WebsocketGlobalChat],
        deny: []
    },
    "AllowConsolidateDuplicates": {
        allow: [Feature.AllowConsolidateDuplicates],
        deny: []
    },
    "JobModule": {
        allow: [Feature.JobModule],
        deny: []
    },
    "JobModuleAdmin": {
        allow: [Feature.JobModule, Feature.JobModuleAdmin],
        deny: []
    },
    "JobModuleGlobalAdmin": {
        allow: [Feature.JobModule, Feature.JobModuleAdmin, Feature.JobModuleGlobalAdmin],
        deny: []
    },
    "DuplicateLayerFiltered": {
        allow: [Feature.DuplicateLayerFiltered],
        deny: []
    },
    "StylingSelectPointType": {
        allow: [Feature.StylingSelectPointType],
        deny: []
    },
    "AnnotationModule": {
        allow: [Feature.AnnotationModule, Feature.AnnotationRead],
        deny: []
    },
    "AnnotationWrite": {
        allow: [Feature.AnnotationModule, Feature.AnnotationRead, Feature.AnnotationWrite],
        deny: []
    },
    "AnnotationDelete": {
        allow: [Feature.AnnotationModule, Feature.AnnotationRead, Feature.AnnotationDelete],
        deny: []
    },
    "AnnotationWriteDelete": {
        allow: [Feature.AnnotationModule, Feature.AnnotationRead, Feature.AnnotationWrite, Feature.AnnotationDelete],
        deny: []
    },
    "AnnotationAuthUser": {
        allow: [Feature.AnnotationModule, Feature.AnnotationRead, Feature.AnnotationWrite, Feature.AnnotationDelete, Feature.AnnotationAuthUser],
        deny: []
    },
    "ServitutEditor": {
        allow: [Feature.ServitutEditor],
        deny: []
    },
    "ServitutAIAnalyse": {
        allow: [Feature.ServitutAIAnalyse],
        deny: []
    },
    "FetchTingbogAktBilag": {
        allow: [Feature.FetchTingbogAktBilag],
        deny: []
    },
    "SimulateOtherUser": {
        allow: [Feature.SimulateOtherUser],
        deny: []
    },
    "EditAccessRights": {
        allow: [Feature.EditAccessRights],
        deny: []
    },
};

/**
 * Appication Mode Based Access Parameters
 */
export const FeaturesAccessibleByMode: FeatureAllowDenyListMap = {
    [AppMode.Embedded]: {
        allow: [],
        deny: [
            Feature.DeviceLocation,
            Feature.GeodataReport,
            Feature.POI,
            Feature.SaveLink,
            Feature.BackgroundLayerBBRData,
            Feature.BackgroundLayerCadaster,
            Feature.BackgroundLayerEjerData,
            Feature.BackgroundLayerZoning,
            Feature.ShowLayerControls,
            Feature.SaveMap,
            Feature.ShowMenu,
            Feature.ShowMapSettings,
            Feature.ShowMapScale,
            Feature.TravelTime,
            Feature.TravelTimeMultiple,
            Feature.GettingStarted,
            Feature.ShowReleases,
            Feature.CreateMarker,
            Feature.MeasurementTool,
        ],
    },
    [AppMode.ReadOnly]: {
        allow: [],
        deny: [
            Feature.DeviceLocation,
            Feature.SearchBar,
            Feature.BasicMap,
            Feature.SaveMap,
            Feature.SaveLink,
            Feature.GettingStarted,
            Feature.ShowReleases,
        ],
    },
    [AppMode.Normal]: {
        allow: [],
        deny: [],
    },
};

/**
 * Application modes based on screen size
 */
export const FeaturesAccessibleByScreenSize: FeatureAllowDenyListMap = {
    [DeviceScreenSize.Phone]: {
        allow: [Feature.DeviceScreenSizePhone],
        deny: [
            Feature.DeviceScreenSizeTablet,
            Feature.DeviceScreenSizeNormal,
            Feature.SaveLink,
            Feature.GeodataReport,
            Feature.DrawCircle,
            Feature.SpatialExport,
            Feature.SpatialExportGeoJSON,
            Feature.SpatialExportGeoJSONInverse,
            Feature.SpatialExportGeoJsonPreview,
            Feature.Explorer,
            Feature.ExplorerOwnership,
            Feature.ExplorerExplore,
            Feature.ExplorerProjects,
            Feature.StreetView,
            Feature.MeasurementTool,
            Feature.MapPlot,
            Feature.FRPTool,
            Feature.Servituterklaering,
        ],
    },
    [DeviceScreenSize.Tablet]: {
        allow: [Feature.DeviceScreenSizeTablet],
        deny: [
            Feature.DeviceScreenSizePhone,
            Feature.DeviceScreenSizeNormal,

            Feature.GeodataReport,
            Feature.DrawCircle,
            Feature.SpatialExport,
            Feature.SpatialExportGeoJSON,
            Feature.SpatialExportGeoJSONInverse,
            Feature.SpatialExportGeoJsonPreview,
            Feature.Explorer,
            Feature.ExplorerOwnership,
            Feature.ExplorerExplore,
            Feature.ExplorerProjects,
            Feature.StreetView,
            Feature.MeasurementTool,
            Feature.MapPlot,
            Feature.FRPTool,
            Feature.Servituterklaering,
        ],
    },
    [DeviceScreenSize.Normal]: {
        allow: [Feature.DeviceScreenSizeNormal],
        deny: [Feature.DeviceScreenSizeTablet, Feature.DeviceScreenSizePhone],
    },
};

/**
 * Application modes based on screen size
 */
export const FeaturesAccessibleByLicenseType: FeatureAllowDenyListMap = {
    [LicenseType.Trial]: {
        allow: [],
        deny: [
            Feature.ExportFloodingProperties,
            Feature.ExplorerToExcel,
            Feature.PropertyExcel,
            Feature.ExplorerImportExport,
            Feature.ExplorerSaveAsNewLayer,
            Feature.ExplorerShowAsList,
            Feature.SpatialExport,
            Feature.SpatialExportGeoJSON,
            Feature.SpatialExportGeoJSONInverse,
            Feature.SpatialExportGeoJsonPreview,
            Feature.Debugging,
            Feature.EarlyPreview,
            Feature.GeodataReport,
            Feature.PowerUser,
            Feature.PrintPropertyInfo,
            Feature.PrintPersonInfo,
            Feature.MapPlotSuper,
            Feature.MapPlotLogo,
            Feature.SaveLinkAllowMapPlot,
            Feature.ShareFavoriteBackgroundLayers,
        ],
    },
    [LicenseType.Subscription]: {
        allow: [],
        deny: [],
    },
    [LicenseType.OneOff]: {
        allow: [],
        deny: [],
    },
};
